export const styles = {
  Textarea: {
    height: 'auto', // based on rows
    resize: 'vertical'
  }
};
